import React, { useState} from 'react';
import { ChevronRight, Code, Mail, Users, Globe, Github, Linkedin, MessageSquare, BookOpen, Calendar, Menu, X } from 'lucide-react';

const Homepage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className="bg-white shadow-sm relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center">
              <div className="flex items-center">
                <Code className="h-10 w-10 text-indigo-600" />
                <span className="ml-2 text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 text-transparent bg-clip-text">
                  CodeSpirit
                </span>
              </div>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-indigo-600 font-medium">Home</a>
              <a href="/coming-soon" className="text-gray-700 hover:text-indigo-600 font-medium">Hackathons</a>
              <a href="/contact" className="text-gray-700 hover:text-indigo-600 font-medium">Contact Us</a>
              <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">
                Join Now
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-indigo-600 focus:outline-none"
              >
                {isMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                <a
                  href="/"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Home
                </a>
                <a
                  href="/coming-soon"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Hackathons
                </a>
                <a
                  href="/contact"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Contact Us
                </a>
                <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">
                Join Now
              </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <main className="flex-grow">
        <div className="relative bg-white overflow-hidden">
          <div className="max-w-7xl mx-auto">
            <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
              <div className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
                <div className="sm:text-center lg:text-left">
                  <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                    <span className="block">Empowering Tech</span>
                    <span className="block text-indigo-600">Innovators Together</span>
                  </h1>
                  <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                    Join our thriving community of 2000+ tech enthusiasts. CodeSpirit provides all-in-one solutions
                    for hackathons, networking, and knowledge sharing.
                  </p>
                  <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                    <div className="rounded-md shadow">
                      <a href="https://whatsapp.com/channel/0029VapOKPqHAdNXNTwL2I1M" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10">
                        Get Started
                        <ChevronRight className="ml-2 h-5 w-5" />
                      </a>
                    </div>
                    <div className="mt-3 sm:mt-0 sm:ml-3">
                      <a href="https://www.linkedin.com/company/codespirit" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-indigo-100 hover:bg-indigo-200 md:py-4 md:text-lg md:px-10">
                        Learn More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-indigo-50 py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-4">
              <div className="flex flex-col items-center">
                <Users className="h-12 w-12 text-indigo-600" />
                <p className="mt-2 text-3xl font-bold text-gray-900">2000+</p>
                <p className="text-gray-600">Community Members</p>
              </div>
             {/* Courses Icon Section */}
  <div className="flex flex-col items-center text-center">
    <BookOpen className="h-12 w-12 text-indigo-600" aria-hidden="true" />
    <p className="mt-2 text-3xl font-extrabold text-gray-900">20+</p>
    <p className="text-sm text-gray-600">Courses Available</p>
  </div>

  {/* Events Icon Section */}
  <div className="flex flex-col items-center text-center">
    <Calendar className="h-12 w-12 text-indigo-600" aria-hidden="true" />
    <p className="mt-2 text-3xl font-extrabold text-gray-900">50+</p>
    <p className="text-sm text-gray-600">Events Hosted</p>
  </div>

              <div className="flex flex-col items-center">
                <Code className="h-12 w-12 text-indigo-600" />
                <p className="mt-2 text-3xl font-bold text-gray-900">100+</p>
                <p className="text-gray-600">Projects Completed</p>
              </div>

<div className="flex flex-wrap justify-around space-y-6 md:space-y-0">
  
</div>



            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center">
                <Code className="h-8 w-8 text-white" />
                <span className="ml-2 text-xl font-bold text-white">CodeSpirit</span>
              </div>
              <p className="mt-4 text-gray-400">
                Building the future of tech communities, one hackathon at a time.
              </p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">About Us</a></li>
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Events</a></li>
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Community</a></li>
                <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Contact</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-6">Connect With Us</h3>
                           <div className="space-y-4">
                             <a href="https://whatsapp.com/channel/0029VapOKPqHAdNXNTwL2I1M" className="flex items-center text-gray-400 hover:text-white">
                               <MessageSquare className="h-6 w-6 mr-3" />
                               <span>Join our WhatsApp Channel</span> 
                             </a>
                             <a href="https://www.linkedin.com/company/codespirit" className="flex items-center text-gray-400 hover:text-white">
                               <Linkedin className="h-6 w-6 mr-3" />
                               <span>Follow us on LinkedIn</span> 
                             </a>
                             <a href="mailto:contact@codespirit.in" className="flex items-center text-gray-400 hover:text-white">
                               <Mail className="h-6 w-6 mr-3" />
                               <span>contact@codespirit.in</span> 
                             </a>
                             <a href="#" className="flex items-center text-gray-400 hover:text-white">
                               <Github className="h-6 w-6 mr-3" />
                               <span>Check our GitHub</span> 
                             </a>
                           </div>
            </div>
          </div>
          <div className="mt-8 border-t border-gray-800 pt-8">
            <p className="text-gray-400 text-center">
              © 2025 <a href="/" className="items-center hover:text-white">
                               <span className='text-blue-600' >CodeSpirit</span> 
                             </a> All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;
